<ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
<div class="relative flex flex-col flex-auto min-w-0 overflow-hidden">

    <!-- Main -->
    <div class="flex flex-col flex-auto px-2 sm:px-1">

        <!-- Note feed -->
        <div class="w-full max-w-3xl">
            <!--Add New Note-->
            <div class="flex justify-end">
                <button mat-stroked-button
                    class="hidden sm:inline-flex ml-3"
                    matTooltip="Add Note" [color]="'primary'"
                    (click)="_fileManagerComponent.editItemNote(null, docId)">
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:plus-circle'"></mat-icon>
                        <!-- <span>{{date| date:'MM-dd-yyyy'}}</span> -->
                    <span class="ml-2">Add New</span>
                </button>
            </div>
            <!-- Title -->          
            <ng-container *ngIf="!isLoading; else loading">
                <ng-container *ngIf="notes.length; else noNote">
                    <div>
                        <ol>
                            <!-- Activities -->
                            <ng-container *ngFor="let note of notes; let i = index; let first = first; let last = last; trackBy: trackByFn">

                                <!-- Date separator; check format of dummy data in data.ts -->
                                <ng-container *ngIf="first || !isSameDay(note.createdDate, notes[i - 1].createdDate)">
                                    <li class="relative flex py-1 underline">
                                        <div class="relative py-2 px-2 text-md font-medium leading-5 ">
                                            {{getRelativeFormat(note.createdDate) | titlecase}}
                                        </div>
                                    </li>
                                </ng-container>
                                <!-- Note -->
                                <li class="relative flex py-1">
                                    <!-- Line -->
                                    <ng-container *ngIf="!last && isSameDay(note.createdDate, notes[i + 1].createdDate)">
                                        <div class="absolute top-7 left-5 w-0.5 h-full -ml-px bg-gray-300 dark:bg-gray-600"></div>
                                    </ng-container>

                                    <div class="relative flex flex-auto">
                                        <!-- Icon -->
                                        <!-- <ng-container *ngIf="note.icon && !note.image">
                                            <div class="flex shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-full bg-gray-400">
                                                <mat-icon
                                                    class="icon-size-5 text-white"
                                                    [svgIcon]="note.icon">
                                                </mat-icon>
                                            </div>
                                        </ng-container> -->

                                        <!-- Image -->
                                        <ng-container>
                                            <div  class="mr-2"
                                         [innerHTML]="note['innerDiv']" [matTooltip]="note.createdBy | fullName">
                                             {{note?.createdBy | fullName}}
                                         </div>
                                        </ng-container>

                                        <!-- Content -->
                                        <div class="flex flex-col flex-auto items-start">
                                            <!-- Author-->
                                            <div class="flex justify-start">
                                                <ng-container *ngIf="note.createdBy">
                                                    <strong class="weight-800">{{note?.createdBy | fullName}}</strong>
                                                </ng-container>
                                                <div class="hidden sm:block ng-star-inserted mx-1">•</div>
                                                <ng-container *ngIf="note.createdDate" class="flex flex-col sm:flex-row sm:items-center mt-2 sm:mt-1 sm:space-x-2 text-md leading-5">
                                                    <div class="text-secondary">{{getDate(note?.createdDate) | date:'hh:mm a, MM/dd/yyyy'}}</div>
                                                </ng-container>
                                               
                                            </div>
                            
                                            <!-- Description -->
                                            <ng-container *ngIf="note.comment" class="mt-1">
                                                <div class="item-note-block">
                                                    <div class="item-note-bubble"
                                                    [innerHTML]="note?.comment"></div>
                                                    <ng-container>
                                                        <button *ngIf="!util.getIsWebApp()" mat-icon-button matTooltip="Edit Note" [disabled]="note?.createdBy?.id !== loginUser?.id"
                                                            class="item-note-edit"
                                                            (click)="_fileManagerComponent.editItemNote({id : note.id,comment : note.comment}, docId)">
                                                            <mat-icon
                                                                class="icon-size-4"
                                                                [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                                                        </button>

                                                        <button *ngIf="util.getIsWebApp()" mat-icon-button matTooltip="Edit Note" [disabled]="note?.createdBy?.id !== util.getUserId()"
                                                            class="item-note-edit"
                                                            (click)="_fileManagerComponent.editItemNote({id : note.id,comment : note.comment}, docId)">
                                                            <mat-icon
                                                                class="icon-size-4"
                                                                [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                                                        </button>
                                                    </ng-container>
                                                </div>
                                               
                                            </ng-container>
                                            <!-- Extra content -->
                                            <!-- <ng-container *ngIf="note.extraContent">
                                                <div
                                                    class="mt-4 py-2 px-2 rounded-lg bg-gray-200 dark:bg-gray-800"
                                                    [innerHTML]="note.extraContent"></div>
                                            </ng-container> -->
                                        </div>
                                    </div>
                                </li>
                            </ng-container>
                        </ol>
                    </div>
                </ng-container>
            </ng-container>

            <!-- Loading template -->
            <ng-template #loading>
                Loading...
            </ng-template>

            <!-- No Note template -->
            <ng-template #noNote>
                There aren't any notes at this time.
            </ng-template>

        </div>
    </div>

</div>
